/**
 * @desc 列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SysGlobalParamResponseDto>>;
export function request(
  params: API.basics.sysGlobalParam.getList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/sysGlobalParam/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
